import { tns } from "tiny-slider/src/tiny-slider";

import lightGallery from 'lightgallery.js';
import '../../vendor/lg-thumbnail.js';
import '../../vendor/lg-video.js';

export const SimpleGallery = {
	selectors: {
		photoOpenSelector: Array.prototype.slice.call(document.querySelectorAll('.js-gallery--open-image')),
	},

	constants: {
		galleriesLoaded: false,
	},

	init: function() {
		let self = this;

		self.renderGallery();

		self.mainGallery();
		self.roomGallery();
		self.userPhotosGallery();
		self.personallyVerifiedGallery();
		self.videoGallery();

		self.bigGallery();
	},

	renderGallery: function() {
		let self = this;
		var thumbItemWidth, thumbItemHeight;
		var gutter = 3;

		if (document.querySelector('.js-simple-gallery')) {
			var slider = tns({
				container: '.js-simple-gallery',
				nav: false,
				items: 1,
				mouseDrag: true,
				slideBy: 'page',
				controlsContainer: '.js-simple-gallery--arrows',
				lazyload: true,
				onInit: function(slider) {
					document.querySelector('.c-simple-gallery').classList.add('is-init');
					window.lightGallery(slider.container, {
						selector: '.js-simple-gallery--slide',
						thumbnails: true,
						subHtmlSelectorRelative: true,
						preload: 1,
					});
				}
			});

			var thumbSlider = tns({
				container: '.js-simple-gallery-thumbs',
				nav: false,
				controls: false,
				items: 4,
				mouseDrag: true,
				slideBy: 'page',
				lazyload: true,
				gutter: gutter,
				responsive: {
					1024: {
						items: 7
					},
					560: {
						items: 5
					}
				},
				onInit: function(slider) {
					thumbItemWidth = self.thumbItemSize(slider.slideItems[0], 'width');
					thumbItemHeight = self.thumbItemSize(slider.slideItems[0], 'height');

					Array.prototype.slice.call(document.querySelectorAll('.js-simple-gallery-thumbs--fake-item')).forEach(function(x) {
						x.style.width = thumbItemWidth - gutter + 'px';
						x.style.marginLeft = gutter + 'px';
					});
				}
			});

			simpleGalleryEvent();
			simpleGalleryThumbsEvent();

			function simpleGalleryEvent() {
				document.querySelector('.js-simple-gallery--arrows .js-simple-gallery--prev').addEventListener('click', function(e) {
					let index = slider.getInfo().index - 1;
					thumbSlider.goTo(index);
				});

				document.querySelector('.js-simple-gallery--arrows .js-simple-gallery--next').addEventListener('click', function(e) {
					let index = slider.getInfo().index + 1;
					thumbSlider.goTo(index);
				});
			};

			function simpleGalleryThumbsEvent() {
				Array.prototype.slice.call(document.querySelectorAll('.js-simple-gallery-thumbs .js-simple-gallery-thumbs--item')).forEach(function(x) {
					x.addEventListener('click', function(e) {
						slider.goTo(this.dataset.galleryId);

						console.log(thumbSlider.getInfo());
					});

				});
			};
		}
	},

	bigGallery: function() {
		let self = this;

		if (document.querySelector('.js-light-gallery')) {
			window.lightGallery(document.querySelector('.js-light-gallery'), {
				selector: '.js-light-gallery--slide',
				thumbnails: true,
				subHtmlSelectorRelative: true,
				preload: 1,
				download: false
			});

			self.selectors.photoOpenSelector.forEach(x => {
				x.addEventListener('click', function(e) {
					e.preventDefault();

					let photoID = this.dataset.photoId;

					if (document.querySelector('.js-light-gallery')) {
						document.querySelector(`.js-light-gallery--slide[data-gallery-id="${photoID}"]`).click();
					}
				});
			});
		}
	},

	thumbItemSize: function(_selector, _side) {
		if (_side === 'width') {
			return _selector.offsetWidth;
		} else if (_side === 'height') {
			return _selector.offsetHeight;
		}
	},

	mainGallery: function() {
		if (document.querySelector('.js-gallery--all-images-open')) {

			Array.prototype.slice.call(document.querySelectorAll('.js-gallery--all-images-open')).forEach(function(element) {
				element.addEventListener('click', function(e) {
					e.preventDefault();

					if (document.querySelector('.js-light-gallery')) {
						document.querySelector('.js-light-gallery--slide[data-gallery-id="0"]').click();
					} else if (document.querySelector('.js-simple-gallery')) {
						document.querySelector('.js-simple-gallery--slide[data-gallery-id="0"]').click();
					}
				});
			});
		}
	},

	roomGallery: function () {
		if (document.querySelector('.js-gallery--room-images-open')) {
			Array.prototype.slice.call(document.querySelectorAll('.js-gallery--room-images-open')).forEach(function (element) {
				window.lightGallery(document.querySelector('.js-room-gallery-' + element.dataset.id), {
					selector: '.js-room-gallery-' + element.dataset.id + '--slide',
					thumbnails: true,
					subHtmlSelectorRelative: true,
					preload: 1,
					download: false
				});

				element.addEventListener('click', function (e) {
					e.preventDefault();
					if (document.querySelector('.js-room-gallery-' + element.dataset.id)) {
						document.querySelector('.js-room-gallery-' + element.dataset.id + '--slide[data-gallery-id="0"]').click();
					}
				});
			});
		}
	},

	userPhotosGallery: function() {
		if (document.querySelector('.js-gallery--other-images')) {
			window.lightGallery(document.querySelector('.js-gallery--other-images'), {
				// selector: 'li',
				thumbnails: true,
				subHtmlSelectorRelative: true
			});

			Array.prototype.slice.call(document.querySelectorAll('.js-gallery--other-images-open')).forEach(function(element) {
				element.addEventListener('click', function(e) {
					e.preventDefault();

					document.querySelector('.js-gallery--other-images li[data-gallery-id="0"]').click();
				});
			});
		}
	},

	personallyVerifiedGallery: function() {
		if (document.querySelector('.js-gallery--personally-verified')) {
			window.lightGallery(document.querySelector('.js-gallery--personally-verified'), {
				// selector: 'li',
				thumbnails: true,
				subHtmlSelectorRelative: true
			});

			Array.prototype.slice.call(document.querySelectorAll('.js-gallery--personally-verified-open')).forEach(function(element) {
				element.addEventListener('click', function(e) {
					e.preventDefault();

					document.querySelector('.js-gallery--personally-verified li[data-gallery-id="0"]').click();
				});
			});
		}
	},

	videoGallery: function() {
		if (document.querySelector('.js-gallery--video')) {
			window.lightGallery(document.querySelector('.js-gallery--video'));

			Array.prototype.slice.call(document.querySelectorAll('.js-gallery--video-open')).forEach(function(element) {
				element.addEventListener('click', function(e) {
					e.preventDefault();

					document.querySelector('.js-gallery--video a').click();
				});
			});
		}
	}
};

SimpleGallery.init();
